export const SHIPPING_TYPES = {
    home_delivery: 'home_delivery',
    box: 'box',
    work_delivery: 'work_delivery',
    pickup_points: 'pickup_points',
} as const;

export const SHIPPING_LIST_TYPES = {
    regular: 'regular',
    pallet: 'pallet',
} as const;
